import React, { FC } from 'react'

interface Props {
  hover: boolean
}

export const ErrorIcon: FC<Props> = ({ hover }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10.0771"
      cy="10.0771"
      r="9.07708"
      stroke={hover ? '#fff' : '#C53D31'}
      strokeWidth="1.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8159 5.77148L10.6599 11.5915H9.51986L9.36386 5.77148H10.8159ZM10.7439 13.9435C10.5759 14.1115 10.3719 14.1955 10.1319 14.1955C9.88386 14.1955 9.67586 14.1115 9.50786 13.9435C9.33986 13.7755 9.25586 13.5675 9.25586 13.3195C9.25586 13.0715 9.33986 12.8635 9.50786 12.6955C9.67586 12.5275 9.88386 12.4435 10.1319 12.4435C10.3719 12.4435 10.5759 12.5275 10.7439 12.6955C10.9119 12.8635 10.9959 13.0715 10.9959 13.3195C10.9959 13.5675 10.9119 13.7755 10.7439 13.9435Z"
      fill={hover ? '#fff' : '#C53D31'}
    />
  </svg>
)
